import { render } from "./App.vue?vue&type=template&id=18e85461"
const script = {}

import "./App.vue?vue&type=style&index=0&id=18e85461&lang=css"
script.render = render

export default script